export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives10.ce506d84.jpg";